module.exports = __webpack_public_path__ + "img/issue-2.571ec602.svg";